import MinHeightPage from '../../../registration/view/MinHeightPage';
import ArcPage from '../../../registration/view/ArcPage';
import SuccessIcon from '../../../../icons/SuccessIcon';
import i18n from '../../../../common/i18n';
import { Button } from '../../../button/Button';
import { getConfig } from '../../../registration/util/config';
import React from 'react';

function ForcedActionStatusDone() {
    return (
        <>
            <MinHeightPage>
                <ArcPage.Top>
                    <div>
                        <SuccessIcon />
                    </div>
                </ArcPage.Top>
                <ArcPage.Body>
                    <h1>{i18n('nui.registrationFinish.title.done')}</h1>
                    <h2>{i18n('nui.registrationFinish.subtitle.done')}</h2>
                </ArcPage.Body>
                <div className="registration-info-end">
                    <div className="px-10 py-10 pb-20 mb-20">
                        <Button
                            className="nui-button-max-300 nui-button-center"
                            primary
                            large
                            onClick={() => getConfig().gotoHomepage()}
                            label={i18n('nui.button.close')}
                            dataAtid="rc-tb-finish"
                        />
                    </div>
                </div>
            </MinHeightPage>
        </>
    );
}

export default ForcedActionStatusDone;
